import {
  GreyDudesIllustration,
  lightColorPalette
} from '@linearb/linui-common';
import { Body2, H2 } from '@linearb/linui-common/typography';
import { Stack } from '@mui/material';

export function InvalidDateRangePlaceholder() {
  return (
    <Stack alignItems='center' gap={5} marginTop={10}>
      <GreyDudesIllustration />

      <Stack gap={1} alignItems='center'>
        <H2 color={lightColorPalette.lbTextSubdued}>
          Please choose a time frame of less than 30 days.
        </H2>
        <Body2 color={lightColorPalette.lbTextSubdued}>
          Open the filter bar on the left and select your time frame to continue
        </Body2>
      </Stack>
    </Stack>
  );
}
